import {
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

const DownloadButtonCellRenderer = ({
  params,
}: {
  params: ICellRendererParams
}) => {
  return (
    <a
      className="block w-28 cursor-pointer rounded-md border-2 border-transparent bg-button-primary px-1.5 py-1 text-center text-xs font-bold capitalize text-white antialiased outline-none transition-all duration-300 hover:border-button-primary hover:bg-button-secondary hover:text-button-primary focus:outline-none"
      href={params.value}
      download
    >
      Confirm
    </a>
  )
}

const columns = [
  {
    headerName: 'Date / Time',
    field: 'createdAt',
    valueFormatter: (params: ValueFormatterParams) =>
      formatDate(params.value, { includeTime: true }),
  },
  { headerName: 'File Name', field: 'fileName' },
  { headerName: 'User', field: 'user' },
  {
    headerName: 'Download',
    field: 'fileUrl',
    cellRenderer: (params: ICellRendererParams) => (
      <DownloadButtonCellRenderer params={params} />
    ),
  },
]

export { columns }
